<template>
  <div style="width: 100%; height: 100%">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
